import { render, staticRenderFns } from "./DetailDeposite.vue?vue&type=template&id=355eb566&scoped=true&"
import script from "./DetailDeposite.vue?vue&type=script&lang=js&"
export * from "./DetailDeposite.vue?vue&type=script&lang=js&"
import style0 from "./DetailDeposite.vue?vue&type=style&index=0&id=355eb566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355eb566",
  null
  
)

export default component.exports